module.exports = __webpack_public_path__ + "static/media/Ian.71873d84.jpg";